import { Tabs, DynamicTable } from "@/components";
import { BankSlipMiniIcon } from "@/styles/icons/BankSlipMiniIcon";
import { PixMiniIcon } from "@/styles/icons/PixMiniIcon";
import { capitalizeFirstLetter, formatCurrency, formatDate } from "@/utils";
import { Flex, Text, useDisclosure, } from "@chakra-ui/react";
import { useCallback, useEffect, useMemo, useState } from "react";
import { usePayment } from "@/hooks/usePayment";
import PaymentDetailDrawer from "../drawer-detalhes-pagamento";
import { DrawerApprovalPayment } from "../drawer-aprovar-pagamento";
import PaymentFilter from "./filter";
import { Button, Tooltip } from "barte-design-system";

export function PaymentsTable() {
    const user = JSON.parse(localStorage.getItem("barte-user-info"));
    const { 
      getListPaymentsInitialData, 
      payments, 
      isPaymentsLoading,
      paginationInfo,
      isNewPaymentDrawerOpen,
    } = usePayment();
    //Disclosure
    const { isOpen, onOpen, onClose } = useDisclosure();
    //Variables
    const sortDirection = 'DESC';
    const sortField = 'scheduledDate';
    const [pageSize, setPageSize] = useState(4);

    const statusOptions = [
        { value: "all", label: "Todos os status" },
        { value: "CREATED", label: "Criado" },
        { value: "REQUESTED", label: "Solicitado" },
        { value: "SCHEDULED", label: "Agendado" },
        { value: "PAID", label: "Pago" },
        { value: "REJECTED", label: "Rejeitado" },
        { value: "FAILED", label: "Falhou" },
        { value: "EXPIRED", label: "Expirado" },
        { value: "PENDING", label: "Pendente" },
        { value: "REFUNDED", label: "Reembolsado" },
        { value: "AWAITING_ANTIFRAUD_ANALYSIS", label: "Pendente" },
    ];
      
    const costCenters = [
        { value: "marketing", label: "Marketing" },
        { value: "vendas", label: "Vendas" },
        { value: "operacional", label: "Operacional" },
        { value: "administrativo", label: "Administrativo" }
    ];

    //States
    const [activeTab, setActiveTab] = useState("SENT");
    const [selectedItems, setSelectedItems] = useState<any[]> ([]);
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [showApprovalModal, setShowApprovalModal] = useState(false);

    //Filters
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    const [statusFilter, setStatusFilter] = useState("all");
    const [costCenterFilter, setCostCenterFilter] = useState("all");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);

    
    //Specific Icons
    const CheckIcon = () => {
        return (
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.967285" y="0.745361" width="12" height="12" rx="3" stroke="black" />
            <path d="M10.8732 3.60083H10.1906C10.0949 3.60083 10.0041 3.64478 9.94547 3.71997L5.9191 8.82056L3.98844 6.37427C3.95923 6.33719 3.92201 6.3072 3.87955 6.28657C3.8371 6.26593 3.79052 6.25518 3.74332 6.25513H3.0607C2.99528 6.25513 2.95914 6.33032 2.99918 6.3811L5.67399 9.76977C5.79899 9.92798 6.03922 9.92798 6.1652 9.76977L10.9347 3.72583C10.9748 3.67603 10.9386 3.60083 10.8732 3.60083V3.60083Z" fill="black" fill-opacity="0.85" />
          </svg>
        )
    }
    const TimeIcon = () => {
        return (
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.967285" y="0.745361" width="12" height="12" rx="3" stroke="black" />
            <path d="M10.8452 3.78931L10.2944 4.21997C9.54346 3.26001 8.37549 2.6438 7.06397 2.6438C4.79932 2.6438 2.96631 4.47485 2.96338 6.74048C2.96045 9.00806 4.79737 10.8469 7.06397 10.8469C8.83448 10.8469 10.3433 9.72388 10.9175 8.15064C10.9321 8.10962 10.9106 8.06372 10.8696 8.05005L10.3159 7.85962C10.2966 7.853 10.2755 7.8542 10.2571 7.86296C10.2386 7.87172 10.2243 7.88735 10.2173 7.90649C10.1997 7.95532 10.1802 8.00415 10.1597 8.052C9.99073 8.45239 9.74854 8.81177 9.43994 9.12036C9.13384 9.42704 8.77142 9.67175 8.37256 9.84106C7.95948 10.0159 7.51905 10.1047 7.06592 10.1047C6.61182 10.1047 6.17237 10.0159 5.75928 9.84106C5.36004 9.67247 4.99748 9.42767 4.6919 9.12036C4.38496 8.8143 4.14051 8.45143 3.97217 8.052C3.79737 7.63794 3.7085 7.19849 3.7085 6.74438C3.7085 6.29028 3.79737 5.85083 3.97217 5.43677C4.14112 5.03638 4.3833 4.677 4.6919 4.36841C5.00049 4.05981 5.35987 3.81763 5.75928 3.64771C6.17237 3.4729 6.6128 3.38403 7.06592 3.38403C7.52002 3.38403 7.95948 3.4729 8.37256 3.64771C8.7718 3.8163 9.13436 4.0611 9.43994 4.36841C9.53662 4.46509 9.62744 4.56763 9.71143 4.67505L9.12354 5.13403C9.11191 5.14303 9.10305 5.15513 9.09799 5.16894C9.09293 5.18275 9.09187 5.1977 9.09493 5.21209C9.09799 5.22647 9.10504 5.2397 9.11529 5.25025C9.12553 5.2608 9.13855 5.26825 9.15283 5.27173L10.8677 5.69165C10.9165 5.70337 10.9644 5.66626 10.9644 5.61646L10.9722 3.84985C10.9712 3.7854 10.896 3.74927 10.8452 3.78931V3.78931Z" fill="black" fill-opacity="0.85" />
            </svg>
        )
    }
    const XIcon = () => {
        return (
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.967285"
              y="0.745361"
              width="12"
              height="12"
              rx="3"
              stroke="black"
            />
            <path
              d="M4.5 4.5L9.5 9.5M9.5 4.5L4.5 9.5"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        )
    }

    //Specific Utils
    const formatPaymentMethod = (paymentMethod: string) => {
        const formattedPayment = {
          PIX: "Pix",
          BANK_SLIP: "Boleto",
          COPY_PASTE_PIX: "Pix Copia e Cola",
        }
        return formattedPayment[paymentMethod] || paymentMethod;
    }
    const formatPaymentMethodIcon = (paymentMethod: string) => {
        const formattedPayment = {
            PIX: <PixMiniIcon />,
            BANK_SLIP: <BankSlipMiniIcon />,
            COPY_PASTE_PIX: <PixMiniIcon />,
        }
        return formattedPayment[paymentMethod] || paymentMethod;
    }
    const formatStatus = (status: string) => {
        const formattedStatus = {
          requested: "Solicitado",
          scheduled: "Agendado",
          approved: "Aprovado",
          paid: "Pago",
          rejected: "Rejeitado",
          processing: "Processando",
          pending: "Pendente",
          failed: "Falhou",
          expired: "Expirado",
          refunded: "Reembolsado",
          returned: "Devolvido",
          cancelled: "Cancelado",
          pending_approval: "Aguardando aprovação"
        }
        return formattedStatus[status.toLocaleLowerCase()] || "Pendente";
    }
    const formatStatusIcon = (status: string) => {
        const formattedStatus = {
            requested: <CheckIcon />,
            paid: <CheckIcon />,
            scheduled: <TimeIcon />,
            processing: <TimeIcon />,
            pending_approval: <TimeIcon />,
            returned: <TimeIcon />,
            refunded: <TimeIcon />,
            cancelled: <XIcon />,
            expired: <XIcon />,
            rejected: <XIcon />,
            failed: <XIcon />,
        }
        return formattedStatus[status.toLocaleLowerCase()] || <CheckIcon />;
    }
    const handleViewPayment = (payment) => {
      setSelectedPayment(payment);
      setShowApprovalModal(true);
    };
    const columns: any[] = [
        {
          key: "scheduledDate",
          title: "Pagamento",
          dataIndex: "scheduledDate",
          sorter: false,
          render: (scheduledDate: string) => (
            <Flex align="center" gridGap="2">
              <Text
                fontWeight={600}
              >
                {scheduledDate ? formatDate(scheduledDate) : "--/--/----"}
              </Text>
            </Flex>
          ),
        },
        {
          key: "transactionType",
          title: "Tipo",
          dataIndex: "transactionType",
          sorter: false,
          render: (transactionType: string) => (
            <Flex
              align="center"
              gridGap="2"
            >
              {formatPaymentMethodIcon(transactionType)}
              <Text>{formatPaymentMethod(transactionType)}</Text>
            </Flex>
          ),
        },
        {
          key: "recipientName",
          title: "Beneficiário",
          dataIndex: "recipientName",
          sorter: false,
          render: (recipientName: string, record: any) => (
            <Flex align="center" gridGap="2">
              <Tooltip label={recipientName}  placement="top">
                <Text
                  maxW={{ base: "120px", md: "195px", lg: "250px" }}
                  textOverflow={{ base: "ellipsis", md: "ellipsis", lg: "unset" }}
                  overflow={{ base: "hidden", md: "hidden", lg: "visible" }}
                  whiteSpace={{ base: "nowrap", md: "nowrap", lg: "normal" }}
                >
                  {recipientName}
                </Text>
              </Tooltip>
            </Flex>
          )
        },
        {
          key: "costCenter",
          title: "Centro de custo",
          dataIndex: "costCenter",
          sorter: false,
          render: (costCenter: string) => (
            <Flex
              align="center"
              gridGap="2"
            >
              <Text>{costCenter ? capitalizeFirstLetter(costCenter) : ""}</Text>
            </Flex>
          ),
        },
        {
          key: "status",
          title: "Status",
          dataIndex: "status",
          sorter: false,
          render: (status: string) => (
            <Flex
              align="center"
              gridGap="2"
              gap="2"
            >
              {formatStatusIcon(status)}
              <Text
                fontWeight={400}
                fontSize="12px"
              >
                {formatStatus(status)}
              </Text>
            </Flex>
          ),
        },
        {
          key: "amount",
          title: "Valor",
          dataIndex: "amount",
          sorter: true,
          render: (amount: number) => (
            <Flex align="center" gridGap="2">
              <Text
                fontWeight={400}
                fontSize="12px"
              >
                {formatCurrency({ value: Number(amount) })}
              </Text>
            </Flex>
          ),
        },
        {
          key: "buttonOptions",
          title: "",
          dataIndex: "",
          render: (value: any, record: any) => (
            <Tooltip label="Visualizar detalhes" >
              <Button
                size="sm"
                variant="outline"
                onClick={(e) => {
                  handleViewPayment(record);
                }}
              >
                Detalhes
              </Button>
            </Tooltip>
          ),
        },
    ];

    //Callbacks // Event handlers
    const handlePageChange = useCallback((newPage) => {
        setCurrentPage(newPage);
    }, []);

    const handleClosePaymentDetails = () => {
      setShowApprovalModal(false);
      setSelectedPayment(null);
    }
  
    // Filtrar
    const fetchPaymentsWithFilters = useCallback(async () => {
        const filter: any = {};

        if (debouncedSearchTerm) {
            filter.name = debouncedSearchTerm;
        }

        // Filtros
        let statusValue: any = undefined;
        if (statusFilter === "all") {
            const tabStatusMap: Record<string, any> = {
                "SENT": statusOptions
                    .map((option) => option.value)
                    .filter(
                        (value) =>
                            !["all", "REQUESTED", "REJECTED", "FAILED", "EXPIRED"].includes(value)
                    ),
                "IN_APPROVAL": "REQUESTED",
                "REJECTED": ["REJECTED", "FAILED", "EXPIRED"],
            };
            statusValue = tabStatusMap[activeTab];
        } else {
            statusValue = statusFilter;
        }

        if (statusValue && !(statusValue === "all")) {
            filter.status = statusValue;
        }

        if (costCenterFilter !== "all") {
            filter.costCenter = costCenterFilter;
        }
        if (startDate) {
            filter.startDate = startDate.toISOString().split('T')[0];
        }
        if (endDate) {
            filter.endDate = endDate.toISOString().split('T')[0];
        }

        const pageable = {
            page: currentPage - 1, // Backend usa 0-based pagination
            size: pageSize,
            sort: `${sortField},${sortDirection}`,
        };

        await getListPaymentsInitialData(filter, pageable);
    }, [
        debouncedSearchTerm,
        statusFilter,
        activeTab,
        statusOptions,
        costCenterFilter,
        startDate,
        endDate,
        currentPage,
        sortField,
        sortDirection,
        pageSize,
        getListPaymentsInitialData,
    ]);
  
    // Debounce search term
    useEffect(() => {
        const timeoutId = setTimeout(() => setDebouncedSearchTerm(searchTerm), 300);
        return () => clearTimeout(timeoutId);
    }, [searchTerm]);

    // Reset de página quando filtros mudam
    useEffect(() => setCurrentPage(1), [
        debouncedSearchTerm,
        statusFilter,
        costCenterFilter,
        startDate,
        endDate,
        sortField,
    ]);

    useEffect(() => {
        if ((isOpen === false && isNewPaymentDrawerOpen === false)) {
            fetchPaymentsWithFilters();
        }
    }, [
      currentPage, 
      sortField, 
      sortDirection, 
      pageSize,
      debouncedSearchTerm, 
      statusFilter, 
      costCenterFilter, 
      startDate, 
      endDate,
      isOpen,
      isNewPaymentDrawerOpen,
      activeTab
    ]);

    useEffect(() => {
        const totalItems = paginationInfo?.totalElements || 0;
        const newTotalPages = totalItems > 0 ? Math.max(1, Math.ceil(totalItems / pageSize)) : 1;
        
        if (currentPage > newTotalPages && newTotalPages > 0) {
            setCurrentPage(newTotalPages);
        }
    }, [pageSize, paginationInfo?.totalElements]);

    const TabSentListContent = useMemo(() => {
        return (
            <Flex
                flexDir="column"
                w="100%"
                position="relative"
            >
                <PaymentFilter
                    searchTerm={searchTerm}
                    onSearchChange={setSearchTerm}
                    searchPlaceholder="Buscar por beneficiário..."
                    statusFilter={statusFilter}
                    onStatusChange={setStatusFilter}
                    statusOptions={statusOptions.filter((option) => option.value !== "REQUESTED" && option.value !== "REJECTED" && option.value !== "FAILED" && option.value !== "EXPIRED" && option.value !== "AWAITING_ANTIFRAUD_ANALYSIS")}
                    costCenterFilter={costCenterFilter}
                    onCostCenterChange={setCostCenterFilter}
                    costCenterOptions={costCenters}
                    startDate={startDate}
                    onStartDateChange={setStartDate}
                    endDate={endDate}
                    onEndDateChange={setEndDate}
                    onClearDateFilters={() => {
                        setStartDate(null);
                        setEndDate(null);
                    }}
                    columns={{ base: 1, md: 2, lg: 5 }}
                    spacing={4}
                />
                <DynamicTable
                    columns={columns}
                    data={payments}
                    rowKey={(record) => record.id}
                    locale={{ emptyText: "Sem dados de pagamentos." }}
                    loading={isPaymentsLoading}
                    customHeight="340px"
                    pagination={{  currentPage: currentPage,
                      pageSize: pageSize,
                      onPageSizeChange: (size) => setPageSize(size),
                      totalItems: paginationInfo.totalElements,
                      totalPages: paginationInfo.totalPages,
                      onPageChange: handlePageChange
                    }}
                    
                />
             
            </Flex>
        );
    }, [
        searchTerm,
        setSearchTerm,
        statusFilter,
        setStatusFilter,
        statusOptions,
        costCenterFilter,
        setCostCenterFilter,
        costCenters,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        columns,
        payments,
        isPaymentsLoading,
        currentPage,
        paginationInfo,
        handlePageChange
    ]);
    const TabInApprovalListContent = useMemo(() => {
        return (
            <Flex
                flexDir="column"
                w="100%"
                position="relative"
            >
                <Flex
                    align="center"
                    gap="4"
                    ml="auto"
                    position="absolute"
                    top="-55px"
                    right="0"
                >
                    {(user?.roles?.includes("BANKING_ADMIN") || user?.roles?.includes("B_SELLER_ADMIN")) && (
                        <Button
                            onClick={onOpen}
                            disabled={selectedItems.length === 0}
                        >
                            Aprovar pagamentos
                        </Button>
                    )}
                </Flex>
                <PaymentFilter
                    searchTerm={searchTerm}
                    onSearchChange={setSearchTerm}
                    searchPlaceholder="Buscar por beneficiário..."
                    statusFilter="REQUESTED"
                    onStatusChange={(value) => setStatusFilter(value)}
                    statusOptions={statusOptions.filter((option) => option.value === "REQUESTED")}
                    costCenterFilter={costCenterFilter}
                    onCostCenterChange={setCostCenterFilter}
                    costCenterOptions={costCenters}
                    startDate={startDate}
                    onStartDateChange={setStartDate}
                    endDate={endDate}
                    onEndDateChange={setEndDate}
                    onClearDateFilters={() => {
                        setStartDate(null);
                        setEndDate(null);
                    }}
                    columns={{ base: 1, md: 2, lg: 5 }}
                    spacing={4}
                />
                <DynamicTable
                    columns={columns}
                    data={payments}
                    rowKey={(record) => record.id}
                    locale={{ emptyText: "Sem dados de pagamentos." }}
                    loading={isPaymentsLoading}
                    rowSelection={{
                        selectedRowKeys: selectedItems.map(selectedItem => selectedItem.transferId),
                        onChange: (keys, rows) => {
                            setSelectedItems(rows);
                        },
                        rowKey: (record) => record.transferId,
                    }}
                    customHeight="340px"
                    pagination={{  currentPage: currentPage,
                      pageSize: pageSize,
                      onPageSizeChange: (size) => setPageSize(size),
                      totalItems: paginationInfo.totalElements,
                      totalPages: paginationInfo.totalPages,
                      onPageChange: handlePageChange
                    }}
                />
              
            </Flex>
        );
    }, [
        user,
        onOpen,
        selectedItems,
        searchTerm,
        setSearchTerm,
        statusFilter,
        setStatusFilter,
        statusOptions,
        costCenterFilter,
        setCostCenterFilter,
        costCenters,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        columns,
        payments,
        isPaymentsLoading,
        currentPage,
        paginationInfo,
        handlePageChange
    ]);
    const TabRejectedListContent = useMemo(() => {
        return (
            <Flex
                flexDir="column"
                w="100%"
                position="relative"
            >
                <PaymentFilter
                    searchTerm={searchTerm}
                    onSearchChange={setSearchTerm}
                    searchPlaceholder="Buscar por beneficiário..."
                    statusFilter={statusFilter}
                    onStatusChange={(value) => setStatusFilter(value)}
                    statusOptions={statusOptions.filter((option) => (option.value === "all" || option.value === "REJECTED" || option.value === "FAILED" || option.value === "EXPIRED"))}
                    costCenterFilter={costCenterFilter}
                    onCostCenterChange={setCostCenterFilter}
                    costCenterOptions={costCenters}
                    startDate={startDate}
                    onStartDateChange={setStartDate}
                    endDate={endDate}
                    onEndDateChange={setEndDate}
                    onClearDateFilters={() => {
                        setStartDate(null);
                        setEndDate(null);
                    }}
                    columns={{ base: 1, md: 2, lg: 5 }}
                    spacing={4}
                />
                <DynamicTable
                    columns={columns}
                    data={payments}
                    rowKey={(record) => record.transferId}
                    locale={{ emptyText: "Sem dados de pagamentos." }}
                    loading={isPaymentsLoading}
                    customHeight="340px"
                    pagination={{  currentPage: currentPage,
                      pageSize: pageSize,
                      onPageSizeChange: (size) => setPageSize(size),
                      totalItems: paginationInfo.totalElements,
                      totalPages: paginationInfo.totalPages,
                      onPageChange: handlePageChange
                    }}
                />
         
            </Flex>
        
        );
    }, [
      user,
      onOpen,
      selectedItems,
      searchTerm,
      setSearchTerm,
      statusFilter,
      setStatusFilter,
      statusOptions,
      costCenterFilter,
      setCostCenterFilter,
      costCenters,
      startDate,
      setStartDate,
      endDate,
      setEndDate,
      columns,
      payments,
      isPaymentsLoading,
      currentPage,
      paginationInfo,
      handlePageChange
    ]);
    const tabs = [
        {
          key: "SENT",
          label: "Enviados",
          content: TabSentListContent,
        },
        {
          key: "IN_APPROVAL",
          label: "Em aprovação",
          content: TabInApprovalListContent,
        },
        {
          key: "REJECTED",
          label: "Rejeitados",
          content: TabRejectedListContent,
        },
    ]

    const handleChangeTab = (key: string) => {
        if (key === "SENT") {
            setStatusFilter("all");
            setActiveTab(key);
        } 
        if (key === "IN_APPROVAL") {
            setStatusFilter("REQUESTED");
            setActiveTab(key);
        }
        if (key === "REJECTED") {
            setStatusFilter("all");
            setActiveTab(key);
        }
    }

    return (
        <>
            {/* Approval Modal */}
            <DrawerApprovalPayment
              isOpen={isOpen}
              onClose={onClose}
              selectedPayments={selectedItems}
            />
            <PaymentDetailDrawer
              isOpen={showApprovalModal}
              onClose={handleClosePaymentDetails}
              payment={selectedPayment}
            />
            <Tabs
                tabs={tabs}
                currentKey={activeTab}
                onChange={handleChangeTab}
            />
        </>
    );
}
